import React, { useState } from 'react';
import classNames from 'classnames';
import Icon from '../Icon/Icon.js';
import Image from '../Image/Image.js';
import styles from './ImageCarousel.module.scss.js';

var ImageCarousel = function (_a) {
    var _b, _c, _d, _e;
    var carouselItems = _a.carouselItems;
    var _f = useState(0), imageIndex = _f[0], setImageIndex = _f[1];
    var currentlySelectedImage = (_c = (_b = carouselItems[imageIndex]) === null || _b === void 0 ? void 0 : _b.img) !== null && _c !== void 0 ? _c : null;
    var descriptionText = (_e = (_d = carouselItems[imageIndex]) === null || _d === void 0 ? void 0 : _d.descriptionText) !== null && _e !== void 0 ? _e : '';
    var prevImage = function () {
        if (imageIndex === 0) {
            setImageIndex(carouselItems.length - 1);
        }
        else {
            setImageIndex(function (prevIndex) { return prevIndex - 1; });
        }
    };
    var nextImage = function () {
        if (imageIndex === carouselItems.length - 1) {
            setImageIndex(0);
        }
        else {
            setImageIndex(function (prevIndex) { return prevIndex + 1; });
        }
    };
    return (React.createElement("section", { className: styles.wrapper },
        React.createElement("div", { className: styles.imageContainer },
            React.createElement(Icon, { size: "large", className: styles.arrowLeft, icon: "icon-arrow-left", onClick: prevImage }),
            React.createElement(Image, { url: currentlySelectedImage, className: styles.displayedImage }),
            React.createElement(Icon, { size: "large", className: styles.arrowRight, icon: "icon-arrow-right", onClick: nextImage }),
            descriptionText && React.createElement("p", { className: styles.descriptionText }, descriptionText)),
        React.createElement("div", { className: styles.imgSelectionContainer }, carouselItems.map(function (item, i) { return (React.createElement("button", { type: "button", onClick: function () { return setImageIndex(i); }, key: (item === null || item === void 0 ? void 0 : item.descriptionText) || i, className: classNames(styles.selectionImage, i === imageIndex && styles.currentlySelected) },
            React.createElement(Image, { className: styles.thumb, url: item === null || item === void 0 ? void 0 : item.img }))); }))));
};

export { ImageCarousel as default };
